module.exports = __webpack_public_path__ + "static/media/cgc.0b3fa15b.svg";